import React, { useState } from "react";
import { Box, Skeleton } from "@mui/material";
import MenuBookIcon from "@mui/icons-material/MenuBook";

const LazyImage = ({ src, alt, sx = {}, ...props }) => {
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(false);

  const handleLoad = () => {
    // console.log("Image loaded successfully:", src);
    setLoading(false);
  };

  const handleError = () => {
    console.error("Failed to load image:", src);
    setError(true);
    setLoading(false);
  };

  // Common styles for container
  const containerStyles = {
    position: "relative",
    width: "100%",
    height: "100%",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    backgroundColor: "#f0f0f0",
    ...sx,
  };

  // Common styles for image
  const imageStyles = {
    width: "100%",
    height: "100%",
    objectFit: "cover",
    display: "block",
  };

  if (error) {
    return (
      <Box sx={{ ...containerStyles, backgroundColor: "#e8e8e8" }}>
        <MenuBookIcon sx={{ fontSize: 64, color: "#aaa" }} />
      </Box>
    );
  }

  return (
    <Box sx={containerStyles}>
      {loading && (
        <Box
          sx={{
            position: "absolute",
            width: "100%",
            height: "100%",
            zIndex: 1,
          }}
        >
          <Skeleton
            variant="rectangular"
            animation="wave"
            width="100%"
            height="100%"
          />
        </Box>
      )}
      <img
        src={src}
        alt={alt}
        onLoad={handleLoad}
        onError={handleError}
        style={{
          ...imageStyles,
          transition: "opacity 0.3s ease-in-out",
          opacity: loading ? 0 : 1,
        }}
        {...props}
      />
    </Box>
  );
};

export default LazyImage;
